import { render, staticRenderFns } from "./SharedGallerySlider.vue?vue&type=template&id=150ccad2"
import script from "./SharedGallerySlider.vue?vue&type=script&lang=js"
export * from "./SharedGallerySlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports